import { createAuthClient } from 'better-auth/react'

/**
 * Same origin as the site, so no baseURL host is needed — the cookie just
 * works. In development Vite proxies /api to the Node server.
 */
export const authClient = createAuthClient({
  basePath: '/api/auth',
})

export const { signIn, signOut, useSession } = authClient

/**
 * Signing in and out end with a full page load, never navigate().
 *
 * This tab's session store still holds the previous answer, so after a
 * sign-in the next layout read "signed out" and bounced back to /login.
 * And the query cache still held the previous person's data: on a shared
 * tablet the next child saw the last one's lessons, and the exercises came
 * pre-filled with their answers, ready to be submitted as their own. A page
 * load starts both empty.
 */
export function enter(path: string): void {
  window.location.assign(path)
}

export async function signOutAndLeave(): Promise<void> {
  try {
    await signOut()
  } finally {
    window.location.assign('/login')
  }
}

export { sessionUnreachable } from './session.js'
